import PropTypes from 'prop-types'
import React from 'react'

import List from 'components/List'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import { biomeNutrition } from 'routes'
import { Text } from 'shared/Typography'
import { Button } from 'shared/Button'

import BAboutSubscriptionInner from './components/BAboutSubscriptionInner'
import { StyledList, BoxBaseStyled, ContentRow, ListRow } from './styles'

const BAboutSubscription = ({ data, pathCdn, pathShared }) => {
  const { dict, locale } = React.useContext(LocalizationContext)
  const { mobile } = React.useContext(ResizeContext)

  return (
    <BoxBaseStyled>
      <ContentRow>
        <Text
          size={['50/60', '50/60', '30/40']}
          weight={'medium'}
          dangerouslySetInnerHTML={{ __html: data.title }}
        />

        <Text
          size={['18/28', '18/28', '16/20']}
          weight={'medium'}
          dangerouslySetInnerHTML={{ __html: data.content }}
        />
      </ContentRow>

      <ListRow>
        <article>
          <StyledList>
            {data.list.map((item, index) => (
              <List.Item key={index} bulletColor="black">
                {item.title}
              </List.Item>
            ))}
          </StyledList>
          {!mobile && (
            <Button
              href={biomeNutrition.link(locale)}
            >
              {dict.buttons.learn_more}
            </Button>
          )}
        </article>
        <BAboutSubscriptionInner {...{ pathShared, pathCdn }} />
      </ListRow>
    </BoxBaseStyled>
  )
}

BAboutSubscription.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
  pathShared: PropTypes.string.isRequired,
}

BAboutSubscription.defaultProps = {}

export default BAboutSubscription
